import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

interface CaptureLogsOptionProps {
  checked: boolean;
  disabled: boolean;
  onChange: (captureLogs: boolean) => void;
}

/** "Capture logs" for an impersonation: the chosen browser or app sends its logs to support. */
export function CaptureLogsOption({ checked, disabled, onChange }: CaptureLogsOptionProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
      }
      label={
        <Box>
          <Typography variant="body2">Capture logs</Typography>
          <Typography variant="caption" color="text.secondary">
            The browser or app sends its logs for this session, for support diagnosis.
          </Typography>
        </Box>
      }
    />
  );
}

export default CaptureLogsOption;
